import React from 'react';
import type SoftwareClassicFeaturesType from '@atlassian/jira-spa-apps-software-classic-features/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazySoftwareClassicFeatures = lazyForPaint<typeof SoftwareClassicFeaturesType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-classic-features", jiraSpaEntry:  "async-classic-features" */ '@atlassian/jira-spa-apps-software-classic-features'
		),
	),
);

export const ClassicFeaturesPage = () => (
	<LazyPage Page={LazySoftwareClassicFeatures} pageId="classic-features" shouldShowSpinner />
);
